/**
 * Service pour la gestion des contacts clients par les admins
 */
import api from './api';
import type {
    ClientMember,
    ClientMemberCreate,
    ClientMemberUpdate,
} from '../types/client';

class AdminClientMembersService {
    /**
     * Liste les contacts d'un client
     */
    async list(clientId: number): Promise<ClientMember[]> {
        const response = await api.get<ClientMember[]>(`/clients/${clientId}/contacts`);
        return response.data;
    }

    /**
     * Crée un nouveau contact pour un client
     */
    async create(clientId: number, data: ClientMemberCreate): Promise<ClientMember> {
        const response = await api.post<ClientMember>(`/clients/${clientId}/contacts`, data);
        return response.data;
    }

    /**
     * Met à jour un contact
     */
    async update(clientId: number, contactId: number, data: ClientMemberUpdate): Promise<ClientMember> {
        const response = await api.patch<ClientMember>(`/clients/${clientId}/contacts/${contactId}`, data);
        return response.data;
    }

    /**
     * Supprime un contact
     */
    async delete(clientId: number, contactId: number): Promise<void> {
        await api.delete(`/clients/${clientId}/contacts/${contactId}`);
    }
}

export default new AdminClientMembersService();
